export const QUESTION_DIFFICULTY = {
  1: 'Easy',
  2: 'Moderate',
  3: 'Tough',
};
